import { render, staticRenderFns } from "./sdproduct11.vue?vue&type=template&id=3b03e582&scoped=true"
import script from "./sdproduct11.vue?vue&type=script&lang=js"
export * from "./sdproduct11.vue?vue&type=script&lang=js"
import style0 from "./sdproduct11.vue?vue&type=style&index=0&id=3b03e582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03e582",
  null
  
)

export default component.exports